import { baseApi } from '@api/baseApi';
import { DayOrdersStatistics } from '@api/shipping-data/types/DayOrdersStatistics';
import { GpsTrack } from '@api/shipping-data/types/GpsTrack';



const shippingDataApi = baseApi.injectEndpoints({
	overrideExisting: false,
	endpoints: (builder) => ({

		// preview statistics
		dayOrdersStatisticsSummary: builder.query<DayOrdersStatistics, string>({
			query: (date) => ({
				url: 'ShippingDataWeb/GetDayOrdersStatisticsSummary',
				params: { date }
			}),
			keepUnusedDataFor: 0,
			providesTags: ['previewStatistics']
		}),

		resetDayOrdersStatisticsSummary: builder.mutation<null, void>({
			queryFn: () => ({ data: null }),
			invalidatesTags: ['previewStatistics'],
		}),


		// map gps
		getOrderGpsTrack: builder.query<GpsTrack[], { date: string, customerId: string }>({
			query: ({ date, customerId }) => ({
				url: 'ShippingDataWeb/GetOrderGpsTrack',
				params: { date, customerId }
			}),
			providesTags: ['orderGpsTrack']
		}),

		resetOrderGpsTrack: builder.mutation<null, void>({
			queryFn: () => ({ data: null }),
			invalidatesTags: ['orderGpsTrack'],
		}),
	}),
});


export const {
	// preview statistics
	useLazyDayOrdersStatisticsSummaryQuery,
	useResetDayOrdersStatisticsSummaryMutation,
	// map gps
	useGetOrderGpsTrackQuery,
	useResetOrderGpsTrackMutation } = shippingDataApi;